var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1232"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1232"
    },
    "bundlingPackage": "billing-portal-ui",
    "bundlingPackageVersion": "static-1.2022",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};